import { Injectable } from '@angular/core';
import { StepImpl } from '../../models/steps/step-impl';
import { TranslationsService } from '../translations/translations.service';
import { Step } from '../../models/intefaces/step';
import { IntroductionStepFactoryService } from '../introduction-step-factory/introduction-step-factory.service';
import { FormStep } from '../../models/steps/form-step';
import { DynamicFormService } from '../dynamic-form/dynamic-form.service';
import { OrderService } from '../order/order.service';
import { SummaryStep } from '../../models/steps/summary-step';
import { CongratulationStep } from '../../models/steps/congratulation-step';

@Injectable({
  providedIn: 'root',
})
export class StepFactoryService {
  private readonly steps: StepImpl[] = [];

  constructor(
    private readonly translationsService: TranslationsService,
    private readonly introductionStepFactory: IntroductionStepFactoryService,
    private readonly dynamicForm: DynamicFormService,
    private readonly orderService: OrderService
  ) {}

  getSteps(): StepImpl[] {
    return this.steps;
  }

  createSteps(): StepImpl[] {
    const steps = this.translationsService.getTranslations().steps;
    this.steps.push(
      this.introductionStepFactory.createIntroductionStep(steps[0])
    );
    steps
      .slice(1)
      .filter((step: Step) => 'content-name' in step)
      .forEach((step: Step) => this.steps.push(this.createFormStep(step)));
    this.steps.push(
      new StepImpl(steps[steps.length - 2].text, steps[steps.length - 2].name)
    );
    this.steps.push(
      new SummaryStep(
        steps[steps.length - 1].text,
        steps[steps.length - 1].name
      )
    );
    this.steps.push(new CongratulationStep());
    return this.steps;
  }

  private createFormStep(step: Step): StepImpl {
    const forms = this.dynamicForm.getForms(step['content-name'] as string);
    this.orderService.load(forms);
    return new FormStep(step.text, step.name, forms);
  }
}
